(function () {
  'use strict';
  if (window.bfMobileStoryLoaded) return;
  window.bfMobileStoryLoaded = true;
  var instances = new WeakMap();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function clamp(value, max) { return Math.max(0, Math.min(value, max)); }
  function initGallery(root) {
    if (instances.has(root)) return;
    var viewport = root.querySelector('[data-bf-story-viewport]');
    var track = root.querySelector('[data-bf-story-track]');
    var progress = root.querySelector('[data-bf-story-progress]');
    var thumb = root.querySelector('[data-bf-story-thumb]');
    if (!viewport || !track || !progress || !thumb) return;
    var listeners = [], drag = null;
    function listen(target, name, handler) { target.addEventListener(name, handler); listeners.push([target, name, handler]); }
    function maximum() { return Math.max(0, viewport.scrollWidth - viewport.clientWidth); }
    function travel() { return Math.max(0, progress.clientWidth - thumb.clientWidth); }
    function sync() {
      var max = maximum(), ratio = max ? viewport.scrollLeft / max : 0;
      progress.hidden = max < 1;
      thumb.style.transform = 'translateX(' + ratio * travel() + 'px)';
      thumb.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    }
    function step() {
      var slides = track.children;
      return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : viewport.clientWidth;
    }
    function snap() {
      var distance = step();
      viewport.scrollTo({ left: clamp(Math.round(viewport.scrollLeft / distance) * distance, maximum()), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    function start(event, isThumb) {
      if (event.button !== 0 || !maximum()) return;
      drag = { x: event.clientX, scroll: viewport.scrollLeft, id: event.pointerId, thumb: isThumb, target: event.currentTarget };
      event.currentTarget.setPointerCapture(event.pointerId);
      if (isThumb) { thumb.focus({ preventScroll: true }); event.preventDefault(); }
    }
    function move(event) {
      if (!drag || drag.id !== event.pointerId) return;
      var delta = event.clientX - drag.x;
      if (Math.abs(delta) < 4) return;
      viewport.classList.add('is-dragging');
      event.preventDefault();
      viewport.scrollLeft = clamp(drag.scroll + (drag.thumb ? delta / Math.max(1, travel()) * maximum() : -delta), maximum());
      sync();
    }
    function end(event) {
      if (!drag || drag.id !== event.pointerId) return;
      if (drag.target.hasPointerCapture(event.pointerId)) drag.target.releasePointerCapture(event.pointerId);
      drag = null;
      viewport.classList.remove('is-dragging');
      snap();
    }
    listen(viewport, 'scroll', sync);
    listen(viewport, 'pointerdown', function (event) { start(event, false); });
    listen(thumb, 'pointerdown', function (event) { start(event, true); });
    [viewport, thumb].forEach(function (target) { listen(target, 'pointermove', move); listen(target, 'pointerup', end); listen(target, 'pointercancel', end); });
    listen(progress, 'pointerdown', function (event) {
      if (event.target === thumb || !maximum()) return;
      var x = event.clientX - progress.getBoundingClientRect().left - thumb.clientWidth / 2;
      viewport.scrollLeft = clamp(x, travel()) / Math.max(1, travel()) * maximum();
      snap();
    });
    function keydown(event) {
      var next;
      if (event.key === 'ArrowRight') next = viewport.scrollLeft + step();
      if (event.key === 'ArrowLeft') next = viewport.scrollLeft - step();
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = maximum();
      if (next === undefined) return;
      event.preventDefault();
      viewport.scrollTo({ left: clamp(next, maximum()), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    listen(viewport, 'keydown', keydown);
    listen(thumb, 'keydown', keydown);
    var observer = null;
    if (window.ResizeObserver) {
      observer = new window.ResizeObserver(function () { window.requestAnimationFrame(sync); });
      observer.observe(viewport);
      observer.observe(progress);
    } else listen(window, 'resize', function () { window.requestAnimationFrame(sync); });
    instances.set(root, function () { if (observer) observer.disconnect(); listeners.forEach(function (item) { item[0].removeEventListener(item[1], item[2]); }); });
    sync();
  }
  function boot(scope) {
    scope.querySelectorAll('[data-bf-story-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-bf-terms-toggle]').forEach(function (button) {
      if (button.dataset.bfTermsReady) return;
      button.dataset.bfTermsReady = 'true';
      button.addEventListener('click', function () {
        var card = button.closest('[data-bf-terms]');
        var collapsed = card.classList.toggle('is-collapsed');
        button.setAttribute('aria-expanded', String(!collapsed));
        button.querySelector('[data-bf-terms-label]').textContent = collapsed ? 'Show More' : 'Show Less';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-bf-story-gallery]').forEach(function (root) { var destroy = instances.get(root); if (destroy) destroy(); instances.delete(root); });
  });
})();
